import * as React from "react";
import { cn } from "../../lib/cn";

export function Section({
  className,
  variant = "white",
  ...props
}) {
  return (
    <section
      className={cn(
        "py-16 md:py-22",
        variant === "white" ? "bg-white" : "bg-brand-bg",
        className
      )}
      {...props}
    />
  );
}
